import { NgModule } from '@angular/core';
import { GroupAssignmentComponent } from './group-assignment/group-assignment.component';
import { RouterModule, Routes } from '@angular/router';
import { GroupAssignmentDetailComponent } from './group-assignment-detail/group-assignment-detail.component';
import { GroupAssignmentDetailResolver } from './group-assignment-detail/group-assignment-detail.resolver';

const routes: Routes = [
  {
    path: '',
    component: GroupAssignmentComponent,
  },
  {
    path: ':groupId',
    resolve: {
      subBreadcrumbs: GroupAssignmentDetailResolver,
    },
    runGuardsAndResolvers: 'always',
    component: GroupAssignmentDetailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardFeatureDashboardGroupAssignmentRoutingModule {}
